module.exports = __webpack_public_path__ + "media/images/icon__compete@3x-dab1c5d8e99d176e0beb2cede5dc40e6.png";